// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".divider-divider--3MyWkphgxHEixD9cswyS4T{margin:16px 0px}", "",{"version":3,"sources":["webpack://src/components/common/Divider/divider.module.scss"],"names":[],"mappings":"AAAA,yCACC,eAAA","sourcesContent":[".divider {\r\n\tmargin: 16px 0px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"divider": "divider-divider--3MyWkphgxHEixD9cswyS4T"
};
export default ___CSS_LOADER_EXPORT___;
